import { render, staticRenderFns } from "./Revistas.vue?vue&type=template&id=38c97576"
import script from "./Revistas.vue?vue&type=script&lang=ts"
export * from "./Revistas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports